import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useReactRouter from 'use-react-router';
import qs from 'query-string';
import { pipe, pick, pickBy, complement, isNil } from 'ramda';
import { CreditApplication, mergeApplication } from 'state/creditApplication';
import canUseDOM from 'utils/canUseDOM';

const useLoadInitialData = (initialDataKeys: string[]) => {
  const dispatch = useDispatch();
  const { location } = useReactRouter();

  const query = useMemo(() => {
    return qs.parse(location.search, {
      parseBooleans: true,
    });
  }, [location]);

  // This is done on the server side to preload the Redux state.
  if (!canUseDOM) {
    const details = pipe(
      pick(initialDataKeys),
      pickBy((v, _) => complement(isNil)(v) && v),
    )(query) as Partial<CreditApplication>;

    // precedence: prefer 'checkoutAmount' over 'cartAmount' over 'productAmount'
    const cascadedAmount =
      details['checkoutAmount'] ||
      details['cartAmount'] ||
      details['productAmount'];

    // only update `intendedPurchaseAmount` with value if non-zero/null
    const updatedDetails = (cascadedAmount
      ? { ...details, intendedPurchaseAmount: cascadedAmount }
      : details) as Partial<CreditApplication>;

    dispatch(mergeApplication(updatedDetails));
  }
};

export default useLoadInitialData;
